import { Divider, IconButton, Popper, ClickAwayListener, Fade } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import PairingSnapshot from "../PairingSnapshot/PairingSnapshot";

export default function DetailView({
    searchState,
    anchorEl,
    selectedPairingId,
    handleSnapClose,
    handleDetailViewClickAway
}) {
    return (
        <Popper className='popper-pairingSnapShot' open={!!anchorEl} anchorEl={anchorEl} placement={'bottom-start'} transition>
            {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={300}>
                    <div>
                        <ClickAwayListener onClickAway={(event) => handleDetailViewClickAway(event)}>
                            <div aria-labelledby='detail-view' className='pairingSnapShot'>
                                <div className='pairingSnapShot-header'>
                                    <span className='pairingSnapShot-title'> {selectedPairingId} </span>
                                        <IconButton
                                            aria-label='close'
                                            onClick={handleSnapClose}
                                            className='pairingSnapShot-close-btn'
                                            size="large">
                                            <CloseIcon fontSize='large' />
                                        </IconButton>
                                </div>
                                <Divider />
                                <PairingSnapshot selectedDate={searchState.selectedDate} />
                            </div>
                        </ClickAwayListener>
                    </div>
                </Fade>
        )}
        </Popper>
    );
}